import { useEffect, useMemo } from 'react';
import { createDirectLine } from 'botframework-webchat';
import { ConnectionStatus } from 'botframework-directlinejs';
import { IDirectLineToken, MessageTypes } from '../core/Interfaces';
import messageBus from '../core/MessageBus';

export default function useCreateDirectLine(tokenData: IDirectLineToken | null) {
  const token = tokenData?.token;
  const directLine = useMemo(() => {
    if (!token) {
      return null;
    }

    return createDirectLine({ token });
  }, [token]);

  useEffect(() => {
    if (!directLine) {
      return;
    }

    const subscription = directLine.connectionStatus$.subscribe((status) => {
      if (status === ConnectionStatus.ExpiredToken || status === ConnectionStatus.FailedToConnect) {
        const getTokenMessage = {
          type: MessageTypes.GetToken,
        };
        messageBus.send(getTokenMessage);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [directLine]);

  return { directLine };
}
